import BookDemoLink from "../../components/bookdemo/BookDemoLink";
import Touchable from "../../components/ui/Touchable";
import Text from "../../components/ui/Text";
import useStore from "../../hooks/store/useStore";
import { EventTrackingSourcePageType } from "../../services/EventTracking/types";
import useEventTracking from "../../services/EventTracking/useEventTracking";
import { tabletMaxWidth } from "../../constants/layout";
import cn from "../../utils/cn";
import openDownloadPage from "../webLogin/utils/openDownloadPage";
import { BookButtonWebHeight } from "./constants";

export default function BookButtonWeb({
  leftButtonText,
  rightButtonText,
  onClick,
  sourcePage,
}: {
  leftButtonText: string;
  rightButtonText: string;
  onClick?: () => void;
  sourcePage?: EventTrackingSourcePageType;
}) {
  const { userInformation } = useStore((state) => state.user);
  const { market, trialUserSegmentation: seg } = userInformation || {};
  const hideBookDemo = seg === "Decision";

  const mutation = useEventTracking();

  const handleEventTracking = () => {
    mutation.mutate({
      pageId: "App Download",
      eventId: "Bottom Button",
    });
  };

  const handleDownloadClick = () => {
    handleEventTracking();

    if (market) openDownloadPage(market);
  };

  const buttonStyle = "flex items-center justify-center";

  const rightButton = (
    <Touchable
      className={cn(
        buttonStyle,
        BookButtonWebHeight,
        "rounded-tr-xl bg-white/25 backdrop-blur",
        sourcePage ? "size-full" : "w-1/2",
      )}
      style={{ boxShadow: "2px 2px 32px rgba(29, 29, 29, 0.10)" }}
      onClick={sourcePage ? undefined : onClick}
    >
      <Text className="text-nowrap text-black8">{rightButtonText}</Text>
    </Touchable>
  );

  const bookDemoButton = sourcePage ? (
    <div
      className={cn(BookButtonWebHeight, "w-1/2 [&>a]:flex [&>a]:size-full")}
    >
      <BookDemoLink sourcePage={sourcePage}>{rightButton}</BookDemoLink>
    </div>
  ) : (
    rightButton
  );

  return (
    <div
      className="fixed bottom-0 left-1/2 z-[5] flex w-full -translate-x-1/2"
      style={{ maxWidth: tabletMaxWidth }}
    >
      <Touchable
        className={cn(
          buttonStyle,
          BookButtonWebHeight,
          "bg-disneyGold",
          hideBookDemo ? "w-full rounded-t-xl" : "w-1/2 rounded-tl-xl",
        )}
        style={{ boxShadow: "-2px 2px 32px rgba(29, 29, 29, 0.10)" }}
        onClick={handleDownloadClick}
      >
        <Text className="text-nowrap text-white">{leftButtonText}</Text>
      </Touchable>

      {hideBookDemo ? null : bookDemoButton}
    </div>
  );
}
